import { useMsalUserSync } from "@/lib/useMsalUserSync.ts";

export function MsalSync() {
  useMsalUserSync();
  return null;
}
